import React from 'react';
import { useLoadScript } from '@react-google-maps/api';
import GoogleMapsAutocomplete from './GoogleMapsAutocomplete';

// Libraries we want to load
const libraries = ["places"];

const GoogleMapsApiLoader = ({
  inputRef,
  setAddressSearch,
  onPlaceSelected,
}) => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries,
  });

  // Only render the enhancer component when script is loaded
  if (isLoaded && !loadError) {
    return (
      <GoogleMapsAutocomplete
        inputRef={inputRef}
        setAddressSearch={setAddressSearch}
        onPlaceSelected={onPlaceSelected}
      />
    );
  }
  
  // Return null when loading or on error
  return null;
};

export default GoogleMapsApiLoader;
